module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_j_leucistic.5514d427.png";